module.exports = __webpack_public_path__ + "img/mirror_frxbiv.2779275d.svg";